export const COLUMN_ACTION_WIDTH = 107;
export const COLUMN_DATE_DELETED_WIDTH = 132;
export const COLUMN_DELETED_FROM_WIDTH = 132;
export const COLUMN_DAYS_TO_RECOVER_WIDTH = 147;
export const COLUMN_DEFAULT_WIDTH = 90;
export const COLUMN_DELETED_BY_WIDTH = 164;
export const COLUMN_TITLE_WIDTH = 360;
export const COLUMN_TYPE_WIDTH = 132;

export const MIN_TABLE_WIDTH =
  COLUMN_TITLE_WIDTH +
  COLUMN_DATE_DELETED_WIDTH +
  COLUMN_DELETED_FROM_WIDTH +
  COLUMN_DAYS_TO_RECOVER_WIDTH +
  COLUMN_DELETED_BY_WIDTH +
  COLUMN_ACTION_WIDTH +
  COLUMN_TYPE_WIDTH;

export const MIN_TABLE_CONTENT_WIDTH = MIN_TABLE_WIDTH + 20;
